// 404 page. Mounted on the catch-all route in App.tsx. Mirrors the Legal
// page shell so a visitor who lands on a dead URL still sees something that
// looks like JobWarp, not a blank screen or a silent redirect.
import { Link } from "react-router-dom";
import { JobWarpIcon } from "../components/JobWarpIcon.js";

export function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-page">
      <header className="border-b border-default">
        <div className="max-w-[960px] mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-primary">
            <JobWarpIcon size={20} />
            <span className="font-serif italic text-[20px] tracking-[-0.01em] leading-none">JobWarp</span>
          </Link>
          <nav className="flex gap-4 text-13">
            <Link to="/privacy/" className="text-secondary hover:text-primary">Privacy</Link>
            <Link to="/terms/" className="text-secondary hover:text-primary">Terms</Link>
          </nav>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-6">
        <div className="text-center max-w-[420px]">
          <div className="font-mono text-tertiary text-[64px] leading-none tracking-mono">404</div>
          <h1 className="text-28 font-medium text-primary mt-6">Page not found</h1>
          <p className="text-secondary text-sm mt-3">
            This page doesn't exist or has moved. Check the link, or head back to start.
          </p>
          <div className="mt-8 flex items-center justify-center gap-3">
            <Link to="/" className="btn-primary">Back to home</Link>
            <Link to="/app" className="btn-secondary">Go to dashboard</Link>
          </div>
        </div>
      </main>

      <footer className="border-t border-default">
        <div className="max-w-[960px] mx-auto px-6 py-6 flex flex-wrap items-center justify-between gap-4 text-tertiary text-11 font-mono uppercase tracking-mono-caps">
          <span>© 2026 JobWarp · Built for job seekers</span>
          <span className="flex gap-4">
            <Link to="/privacy/" className="hover:text-primary">Privacy</Link>
            <Link to="/terms/" className="hover:text-primary">Terms</Link>
          </span>
        </div>
      </footer>
    </div>
  );
}
